type SolutionsChallengesProps = {
  header: string
  sections: {
    title: string
    listitems: string[]
  }[]
}

const SolutionsChallenges = ({ header, sections }: SolutionsChallengesProps) => {
  return (
    <section className="bg-neutral-charcoal/15 py-24 sm:py-16">
      <div className="space-y-8 mx-auto max-w-5xl px-6 lg:px-8">
        <h1 className="text-4xl font-light text-brand-blue">{header}</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-lg leading-relaxed text-text-secondary lg:text-xl">
          {sections.map((section) => (
            <div key={section.title} className="flex flex-col">
              <div className="border-0 border-l-4 border-solid border-brand-blue px-4">
                <h2 className="text-left text-lg font-semibold text-brand-navy">{section.title}</h2>
                <ul className="text-base pl-4 text-brand-navy">
                  {section.listitems.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default SolutionsChallenges
